module.exports = __webpack_public_path__ + "img/bmw-768x357.316016f5.png";